import * as React from 'react';
import styled from 'styled-components';

const ValidationSummaryContainer = styled.div`
    padding: 1rem;
    border-left: 5px solid var(--error-default);
    background-color: color-mix(in srgb, var(--error-default) 10%, transparent);
`;

export type ValidationSummaryProps = {
    children?: React.ReactNode;
    className?: string;
};

export function ValidationSummary({ children, className }: ValidationSummaryProps) {
    return (
        <ValidationSummaryContainer role="alert" className={className}>
            {children}
        </ValidationSummaryContainer>
    );
}
